import { createStore } from 'satcheljs';
import SmartSchedulePollingStateSchema from './schema/SmartSchedulePollingStateSchema';

const initialSmartSchedulePollingState: SmartSchedulePollingStateSchema = {
    isPolling: true, // polling considered always on
    teamId: undefined,
    jobId: undefined,
    status: undefined,
    statusEntity: undefined,
    lastUpdated: undefined
};

const smartSchedulePollingState = createStore<SmartSchedulePollingStateSchema>(
    'smartSchedulePollingState',
    initialSmartSchedulePollingState
);

export { smartSchedulePollingState };
